import {
  Card,
  CardContent,
  CardHeader,
  TextField,
  Box,
  Button,
  FormHelperText,
  CircularProgress,
  useTheme,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import axios from "axios";
import Notify from "src/notification/Notify";
import { UsersData } from "src/ContextAPI";
import { CheckCircle, XCircle } from "react-feather";
import IsMountedRef from "src/utils/IsMountedRef";
import Select from "react-select";
// import SelectStyle from "src/utils/SelectStyle";

const CreateDoctorServiceOrder = ({
  patient_id,
  getPatientBillingDetails,
  getDoctorServiceUnpaidList,
  trace_number,
}) => {
  const { users } = React.useContext(UsersData);
  const [list, setList] = useState([]);
  const mounted = IsMountedRef();
  // const selectStyle = SelectStyle();
  const theme = useTheme();

  const getDoctorServiceList = React.useCallback(async () => {
    let response = await axios.get("cashier/get/add-on/doctorservice-list", {
      params: {
        management_id: users.management_id,
        main_mgmt_id: users.main_mgmt_id,
      },
    });

    if (mounted.current) {
      setList(response.data);
    }
  }, [mounted, users]);

  const getFormData = (object) => {
    const formData = new FormData();

    Object.keys(object).forEach((key) => formData.append(key, object[key]));
    return formData;
  };

  useEffect(() => {
    getDoctorServiceList();
  }, [getDoctorServiceList]);

  return (
    <Formik
      initialValues={{
        username: users.username,
        management_id: users.management_id,
        main_mgmt_id: users.main_mgmt_id,
        user_id: users.user_id,
        patient_id: patient_id,
        trace_number: trace_number,
        department: "doctor",
        services: "",
        amount: "",
        order_id: "",
        password: "",
      }}
      validationSchema={Yup.object().shape({
        services: Yup.string().required(),
        amount: Yup.number().required(),
        password: Yup.string().required(),
      })}
      onSubmit={async (
        values,
        { setErrors, setStatus, setSubmitting, resetForm }
      ) => {
        try {
          const request = await axios.post(
            "cashier/get/order/new-doctorservice",
            getFormData(values)
          );
          if (request.data.message === "pass-invalid") {
            setErrors({ password: "Password is invalid." });
          }
          if (request.data.message === "success") {
            Notify.successRequest("new test");
            getPatientBillingDetails();
            getDoctorServiceUnpaidList();
            resetForm();
            setSubmitting(true);
          }
        } catch (error) {
          const message = error.message || "Something went wrong";
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        touched,
        resetForm,
        values,
      }) => (
        <form noValidate onSubmit={handleSubmit}>
          <Card>
            <CardHeader title="Select Order" />
            <CardContent>
              <Box mb={2}>
                <Select
                  options={list}
                  onChange={(data) => {
                    setFieldValue("services", data.services);
                    setFieldValue("amount", data.amount);
                    setFieldValue("order_id", data.service_id);
                  }}
                  // styles={selectStyle}
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 99999,
                      color: "#000",
                    }),
                    control: (base) => ({
                      ...base,
                      minHeight: 55,
                      backgroundColor: "transparent",
                      color: theme.palette.type === "dark" ? "#fff" : "#fff",
                    }),
                    singleValue: () => ({
                      color: theme.palette.type === "dark" ? "#fff" : "#000",
                    }),
                  }}
                />
              </Box>

              <Box mb={2}>
                <TextField
                  label="Service Rate"
                  fullWidth
                  variant="outlined"
                  error={Boolean(touched.amount && errors.amount)}
                  helperText={touched.amount && errors.amount}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.amount}
                  name="amount"
                  InputProps={{ readOnly: true }}
                />
              </Box>

              <Box>
                <TextField
                  fullWidth
                  required
                  error={Boolean(touched.password && errors.password)}
                  helperText={touched.password && errors.password}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.password}
                  name="password"
                  label="Enter your password"
                  variant="outlined"
                  type="password"
                />
              </Box>

              {errors.submit && (
                <Box mt={2}>
                  <FormHelperText error> {errors.submit} </FormHelperText>
                </Box>
              )}
            </CardContent>

            <CardContent>
              <Box display="flex">
                <Box mr={2}>
                  <Button
                    size="large"
                    variant="contained"
                    color="primary"
                    type="submit"
                    startIcon={
                      isSubmitting ? (
                        <CircularProgress size={23} color="inherit" />
                      ) : (
                        <CheckCircle />
                      )
                    }
                    disabled={isSubmitting}
                  >
                    Save
                  </Button>
                </Box>

                <Button
                  size="large"
                  variant="contained"
                  color="default"
                  onClick={resetForm}
                  startIcon={<XCircle />}
                >
                  No
                </Button>
              </Box>
            </CardContent>
          </Card>
        </form>
      )}
    </Formik>
  );
};

export default CreateDoctorServiceOrder;
